<template>
  <div>
    <v-navigation-drawer
      :model-value="$route.path === '/post'"
      location="right"
      width="400"
      style="z-index: 999"
    >
      <div class="agent-drawer">
        <v-card flat class="d-flex flex-column fill-height pa-0">
          <v-card-text
            class="flex-grow-1 overflow-y-auto"
            style="padding: 16px"
            ref="chatMessages"
          >
            <div
              v-for="(msg, idx) in chat"
              :key="idx"
              ref="lastMessage"
              class="d-flex mb-3"
              :class="msg.role === 'user' ? 'justify-end' : 'justify-start'"
            >
              <div
                class="d-flex flex-column"
                :style="
                  msg.role === 'assistant'
                    ? 'max-width: 100%'
                    : 'max-width: 80%'
                "
              >
                <v-sheet
                  :color="msg.role === 'user' ? 'grey-lighten-4' : ''"
                  rounded="lg"
                  class="pa-3"
                >
                  <div
                    v-if="
                      msg.response_type !== 'post' &&
                      msg.response_type !== 'ideas'
                    "
                  >
                    <!-- <v-img
                      v-if="msg.role === 'assistant'"
                      width="20"
                      class="mb-2"
                      :src="require('@/assets/logo/logo-dark.svg')"
                    ></v-img> -->
                    <div
                      class="text-body-2"
                      v-html="
                        msg.role === 'user'
                          ? msg.content.replace(/\n/g, '<br>')
                          : linkify(
                              JSON.parse(msg.content[0].text).response.replace(
                                /\n/g,
                                '<br>'
                              )
                            )
                      "
                    ></div>
                    <div
                      v-if="msg.sources?.length > 0"
                      class="d-flex flex-column mt-2"
                      style="gap: 5px"
                    >
                      <p style="font-size: 10pt">
                        Add link to your post?
                        {{
                          media[0]?.type === "url"
                            ? `Current link: ${media[0].url}`
                            : ""
                        }}
                      </p>
                      <div v-if="msg.sources.length > 0">
                        <v-card
                          @click="useSource(msg.sources[0])"
                          class="bg-smoke pa-2"
                          variant="text"
                          :loading="msg.sources[0].loading"
                          style="
                            font-size: 10pt;
                            display: flex;
                            align-items: center;
                          "
                        >
                          <v-icon size="12" class="mr-2" color="primary">{{
                            msg.sources[0]?.url === media[0]?.url
                              ? "mdi-check-circle"
                              : "mdi-link-variant"
                          }}</v-icon>
                          {{ msg.sources[0].url }}
                        </v-card>
                      </div>

                      <v-expand-transition>
                        <div
                          v-if="showSources"
                          style="gap: 5px"
                          class="d-flex flex-column"
                        >
                          <v-card
                            @click="useSource(source)"
                            class="bg-smoke pa-2"
                            variant="text"
                            v-for="source in msg.sources.slice(1)"
                            :loading="source.loading"
                            :key="source.url"
                            style="
                              font-size: 10pt;
                              display: flex;
                              align-items: center;
                            "
                          >
                            <v-icon size="12" class="mr-2" color="primary">{{
                              source.url === media[0]?.url
                                ? "mdi-check-circle"
                                : "mdi-link-variant"
                            }}</v-icon>
                            {{ source.url }}
                          </v-card>
                        </div>
                      </v-expand-transition>

                      <v-btn
                        variant="text"
                        size="small"
                        v-if="msg.sources.length > 1"
                        @click="showSources = !showSources"
                        >{{
                          showSources ? "Hide sources" : "See all sources"
                        }}</v-btn
                      >
                    </div>
                    <div
                      v-if="
                        msg.handoff &&
                        msg.handoffDetails.find((h) => h.step === idx)?.to
                      "
                      class="text-caption mt-2 text-grey-darken-1 d-flex align-center"
                    >
                      <v-icon size="16" class="mr-2" color="primary"
                        >mdi-transfer</v-icon
                      >
                      Handed off to
                      <span class="font-weight-medium ml-1">
                        {{ msg.handoffDetails.find((h) => h.step === idx).to }}
                      </span>
                    </div>
                    <!-- <div v-if="msg.response_type" class="mt-2">
                      <v-chip size="x-small" color="info" variant="flat">
                        {{ msg.response_type }}
                      </v-chip>
                    </div> -->
                  </div>
                  <div v-else-if="msg.response_type === 'post'">
                    <div class="d-flex align-center mb-2">
                      <v-icon color="green" size="15" class="mr-2"
                        >mdi-check-circle</v-icon
                      >
                      <span class="text-caption text-grey-darken-1"
                        >Updated Post</span
                      >
                      <v-tooltip text="Rollback to this post" location="top">
                        <template #activator="{ props }">
                          <v-btn
                            class="ml-2"
                            v-bind="props"
                            @click="
                              $store.commit('setPostVariationText', {
                                index: $store.state.post.tab,
                                text: msg.post_content,
                              })
                            "
                            icon="mdi-history"
                            size="x-small"
                            variant="text"
                          ></v-btn>
                        </template>
                      </v-tooltip>
                    </div>
                    <!-- <div
                    class="text-body-2 mb-3"
                    v-html="
                      formatPostContent(
                        msg.post_content || msg.content[0]?.text
                      )
                    "
                  ></div> -->
                    <div class="text-body-2 mb-3">
                      {{ JSON.parse(msg.content[0]?.text).response }}
                    </div>

                    <div class="d-flex mt-4" v-if="msg.sources?.length > 0">
                      <v-icon color="grey" class="mr-3"
                        >mdi-arrow-right-bottom</v-icon
                      >
                      <div class="d-flex flex-column mt-1" style="gap: 5px">
                        <p
                          style="font-size: 10pt; font-weight: 600"
                          class="mb-2"
                        >
                          Add link to your post?

                          {{
                            media[0]?.type === "url"
                              ? `Current link: ${media[0].url}`
                              : ""
                          }}
                        </p>

                        <div v-if="msg.sources.length > 0">
                          <v-card
                            @click="useSource(msg.sources[0])"
                            class="bg-smoke pa-2"
                            variant="text"
                            :loading="msg.sources[0].loading"
                            style="
                              font-size: 10pt;
                              display: flex;
                              align-items: center;
                            "
                          >
                            <v-icon size="12" class="mr-2" color="primary">{{
                              msg.sources[0]?.url === media[0]?.url
                                ? "mdi-check-circle"
                                : "mdi-link-variant"
                            }}</v-icon>
                            {{ msg.sources[0].url }}
                          </v-card>
                        </div>

                        <v-expand-transition>
                          <div
                            v-if="showSources"
                            style="gap: 5px"
                            class="d-flex flex-column"
                          >
                            <v-card
                              @click="useSource(source)"
                              class="bg-smoke pa-2"
                              variant="text"
                              v-for="source in msg.sources.slice(1)"
                              :loading="source.loading"
                              :key="source.url"
                              style="
                                font-size: 10pt;
                                display: flex;
                                align-items: center;
                              "
                            >
                              <v-icon size="12" class="mr-2" color="primary">{{
                                source.url === media[0]?.url
                                  ? "mdi-check-circle"
                                  : "mdi-link-variant"
                              }}</v-icon>
                              {{ source.url }}
                            </v-card>
                          </div>
                        </v-expand-transition>

                        <v-btn
                          variant="text"
                          size="small"
                          v-if="msg.sources.length > 1"
                          @click="showSources = !showSources"
                          >{{
                            showSources ? "Hide sources" : "See all sources"
                          }}</v-btn
                        >
                      </div>
                    </div>
                    <!-- <v-divider></v-divider>
                  <div
                    class="d-flex justify-space-between pt-4"
                    style="gap: 5px"
                  >
                    <v-btn
                      variant="text"
                      size="small"
                      @click="
                        copyToClipboard(
                          msg.post_content || msg.content[0]?.text
                        )
                      "
                    >
                      <v-icon>mdi-content-copy</v-icon>
                    </v-btn>
                    <v-btn
                      color="primary"
                      size="small"
                      variant="text"
                      @click="
                        useContent(
                          msg.post_content || msg.content[0]?.text,
                          null
                        )
                      "
                      class="mr-2"
                    >
                      <v-icon size="16" class="mr-1">mdi-arrow-right</v-icon>
                      Use
                    </v-btn>
                  </div> -->
                  </div>
                  <div v-else-if="msg.response_type === 'ideas'">
                    Here are some ideas:
                  </div>
                </v-sheet>

                <!-- Ideas below the sheet (only for assistant messages with ideas) -->
                <div
                  v-if="
                    msg.role === 'assistant' && msg.response_type === 'ideas'
                  "
                  class="mt-2"
                  style="max-width: 100%"
                >
                  <div v-for="(id, index) in msg.ideas || []" :key="index">
                    <v-list-item
                      class="pa-2 my-1 text-left"
                      color="primary"
                      variant="flat"
                      @click="useIdea(id)"
                    >
                      <div class="d-flex align-center">
                        <v-icon size="13" class="mr-2" color="primary"
                          >mdi-lightbulb-outline</v-icon
                        >
                        {{ id.title }}
                      </div>
                      <div class="pa-2 d-flex" style="gap: 5px">
                        <v-btn
                          size="small"
                          color="accent"
                          @click="sendMessage('Write a post about ' + id.title)"
                          >Write post</v-btn
                        >
                        <v-btn
                          v-if="!id.saved"
                          variant="text"
                          size="small"
                          color="accent"
                          @click="saveIdea(id)"
                          >Save for later</v-btn
                        >
                        <p v-if="id.saved">Saved</p>
                      </div>
                    </v-list-item>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex align-center" style="gap: 10px" v-if="loading">
              <v-progress-circular
                indeterminate
                color="primary"
                size="18"
                width="2"
              ></v-progress-circular>
              <i>Thinking ...</i>
            </div>
            <div ref="scrollSpacer" style="height: 32px"></div>
          </v-card-text>

          <!-- Floating Chat Input Bar -->
          <div class="ma-4">
            <div
              class="pa-4 d-flex justify-end flex-wrap"
              style="gap: 8px"
              v-if="chat.length === 0"
            >
              <v-btn
                block
                color="faded"
                rounded
                variant="text"
                @click="loadRecentChat"
                size="small"
              >
                <v-icon size="12" class="mr-1" color="primary">
                  mdi-history
                </v-icon>
                <span>Continue previous chat</span>
              </v-btn>
              <v-btn
                color="faded"
                size="small"
                block
                rounded
                variant="flat"
                @click="sendMessage('Help me write a post')"
              >
                <v-icon size="12" class="mr-1" color="smoke">mdi-post</v-icon>
                <span class="text-smoke">Help me write a post</span>
              </v-btn>
              <v-btn
                block
                color="faded"
                rounded
                variant="flat"
                @click="sendMessage('Suggest content ideas')"
                size="small"
              >
                <v-icon size="12" class="mr-1" color="smoke"
                  >mdi-lightbulb</v-icon
                >
                <span class="text-smoke">Suggest post ideas</span>
              </v-btn>
            </div>

            <v-expand-transition>
              <v-card
                v-if="expand"
                variant="flat"
                class="bg-smoke mb-2"
                style="border-radius: 10px; border: 1px solid #e0e0e0"
              >
                <v-textarea
                  label="Idea"
                  variant="solo"
                  flat
                  hide-details
                  rows="5"
                  v-model="idea.idea"
                  :style="{
                    background: 'linear-gradient(to right, #000000, #ff0000)',
                    borderRadius: '8px',
                  }"
                >
                </v-textarea>
                <div
                  class="d-flex justify-space-between pa-1"
                  style="width: 100%"
                >
                  <v-btn
                    size="x-small"
                    @click="$store.commit('setIdeasShow', true)"
                    variant="tonal"
                    ><v-icon size="10" class="mr-1">mdi-lightbulb-on</v-icon
                    >Browse ideas</v-btn
                  >
                  <v-btn
                    size="x-small"
                    @click="
                      $store.commit('setPostIdea', { draft: '', idea: '' })
                    "
                    variant="text"
                    ><v-icon size="10" class="mr-1">mdi-close</v-icon>
                    Clear</v-btn
                  >
                </div>
              </v-card>
            </v-expand-transition>

            <v-card
              variant="flat"
              class="bg-smoke"
              style="border-radius: 10px; border: 1px solid #e0e0e0"
            >
              <div
                class="d-flex align-center px-2 pt-2 flex-wrap"
                style="gap: 8px"
              >
                <v-btn
                  :color="idea.idea ? 'button' : 'buttonGrey'"
                  size="x-small"
                  variant="flat"
                  @click="expand = !expand"
                  >Idea
                </v-btn>
                <v-menu>
                  <template v-slot:activator="{ props: menu }">
                    <v-btn size="x-small" variant="tonal" v-bind="menu">
                      Brand
                      <span v-if="brand">: </span>
                      <span
                        :style="
                          brand
                            ? 'text-decoration: underline; text-underline-offset: 2px;'
                            : ''
                        "
                      >
                        {{ brand ? `${brand.name}` : "" }}
                      </span>
                    </v-btn>
                  </template>
                  <v-list density="compact">
                    <v-list-item
                      v-for="(item, index) in brands"
                      :key="index"
                      dense
                      :value="index"
                      @click="brand = item"
                    >
                      <v-list-item-title>{{ item.name }}</v-list-item-title>
                    </v-list-item>

                    <v-list-item @click="brand = null">
                      <v-list-item-title
                        ><v-icon size="12" class="mr-1">mdi-close</v-icon>
                        None</v-list-item-title
                      >
                    </v-list-item>
                  </v-list>
                </v-menu>

                <v-menu>
                  <template v-slot:activator="{ props: menu }">
                    <v-btn size="x-small" variant="tonal" v-bind="menu"
                      >Voice
                      <span v-if="voice">: </span>
                      <span
                        :style="
                          voice
                            ? 'text-decoration: underline; text-underline-offset: 2px;'
                            : ''
                        "
                      >
                        {{ voice ? `${voice.name}` : "" }}
                      </span>
                    </v-btn>
                  </template>
                  <v-list density="compact">
                    <v-list-item
                      v-for="(item, index) in voices"
                      :key="index"
                      :value="index"
                      @click="voice = item"
                    >
                      <v-list-item-title>{{ item.name }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="voice = null">
                      <v-list-item-title
                        ><v-icon size="12" class="mr-1">mdi-close</v-icon>
                        None</v-list-item-title
                      >
                    </v-list-item>
                  </v-list>
                </v-menu>

                <v-menu>
                  <template v-slot:activator="{ props: menu }">
                    <v-btn size="x-small" variant="tonal" v-bind="menu"
                      >Structure
                      <span v-if="structure">: </span>
                      <span
                        :style="
                          structure
                            ? 'text-decoration: underline; text-underline-offset: 2px;'
                            : ''
                        "
                      >
                        {{ structure ? `${structure.title}` : "" }}
                      </span>
                    </v-btn>
                  </template>
                  <v-list density="compact">
                    <v-list-item
                      v-for="(item, index) in structures"
                      :key="index"
                      :value="index"
                      @click="structure = item"
                    >
                      <v-list-item-title>{{ item.title }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="structure = null">
                      <v-list-item-title
                        ><v-icon size="12" class="mr-1">mdi-close</v-icon>
                        None</v-list-item-title
                      >
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>
              <v-form @submit.prevent class="d-flex align-center">
                <v-textarea
                  ref="floatingInputField"
                  v-model="floatingInput"
                  placeholder="Let's write together!"
                  hide-details
                  flat
                  rows="3"
                  variant="solo"
                  bg-color="transparent "
                  :disabled="loading"
                  autocomplete="off"
                  @keydown.enter.meta="sendFloatingMessage"
                  class="floating-text-field text-caption"
                  density="comfortable"
                >
                  <!-- <template v-slot:append>
                    <v-btn
                      color="primary"
                      :disabled="floatingInput.trim() === '' || loading"
                      @click="sendFloatingMessage"
                      elevation="1"
                      icon
                      size="small"
                      class="floating-send-btn"
                    >
                      <v-icon color="white">mdi-send</v-icon>
                    </v-btn>
                  </template> -->
                </v-textarea>
              </v-form>
              <div class="d-flex justify-space-between align-center">
                <div>
                  <!-- <v-menu offset-y>
                    <template #activator="{ props }">
                      <v-btn
                        v-bind="props"
                        prepend-icon="mdi-robot"
                        size="small"
                        variant="text"
                        :title="
                          'Select ChatGPT Model (' +
                          (selectedModel || 'Default') +
                          ')'
                        "
                        rounded
                      >
                        {{ selectedModel || "Auto" }}</v-btn
                      >
                    </template>
                    <v-list density="compact">
                      <v-list-item
                        v-for="model in [
                          { label: 'Auto (recommended)', value: 'auto' },
                          { label: 'GPT-5', value: 'gpt-5' },
                          {
                            label: 'GPT-5-mini (50% token usage)',
                            value: 'gpt-5-mini',
                          },
                        ]"
                        :key="model.value"
                        @click="selectModel(model.value)"
                        :active="selectedModel === model.value"
                      >
                        <v-list-item-title style="font-size: 9pt">
                          {{ model.label }}
                          <span
                            v-if="selectedModel === model.value"
                            style="color: #1976d2; margin-left: 6px"
                          >
                            <v-icon size="14">mdi-check</v-icon>
                          </span>
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu> -->
                  <v-tooltip
                    location="bottom"
                    max-width="200"
                    :text="`${workspace?.counter?.tokens} tokens available of 1M tokens.`"
                  >
                    <template #activator="{ props }">
                      <v-chip size="x-small" variant="text" v-bind="props">
                        {{ tokenUsed }}%
                        <v-progress-circular
                          class="ml-1"
                          color="primary"
                          size="14"
                          width="2"
                          :model-value="tokenUsed"
                        ></v-progress-circular>
                      </v-chip>
                    </template>
                  </v-tooltip>
                </div>
                <div style="gap: 2px" class="d-flex">
                  <!-- <v-btn
                    icon="mdi-file-plus"
                    size="small"
                    variant="default"
                  ></v-btn> -->
                  <v-btn
                    :disabled="floatingInput.trim() === '' || loading"
                    @click="sendFloatingMessage"
                    icon="mdi-arrow-up-circle"
                    size="small"
                    variant="text"
                  ></v-btn>
                </div>
              </div>
            </v-card>
          </div>
        </v-card>
      </div>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { agent } from "@/mixins/agent";
import { post } from "@/mixins/post";
import { httpsCallable } from "firebase/functions";
import { functions } from "@/firebase";
export default {
  mixins: [agent, post],
  watch: {
    "chat.length"(newVal) {
      this.$nextTick(() => {
        console.log(newVal);
        const messages = this.$refs.lastMessage;
        const last = Array.isArray(messages) ? messages.at(-1) : messages;
        if (last?.scrollIntoView) {
          last.scrollIntoView({ behavior: "smooth", block: "start" });
        }

        // Focus the input field after chat updates
        if (this.$refs.floatingInputField) {
          this.$refs.floatingInputField.focus();
        }
      });
    },
  },

  computed: {
    ...mapState({
      userProfile: (state) => state.users.userProfile,
      chat: (state) => (state.agent ? state.agent.chat : []),
      loading: (state) => (state.agent ? state.agent.loading : false),
      workspace: (state) => state.workspace.workspace,
      brands: (state) => state.workspace.brands,
      recent_chat: (state) => state.agent.recent_chat,
      recent_chat_uid: (state) => state.agent.recent_chat_uid,
      structures: (state) => state.structures.structures,
      loadingGeneral: (state) => state.loading.general,
    }),
    tokenUsed() {
      if (!this.workspace?.counter.tokens) return 0;
      return Math.round((this.workspace.counter.tokens / 1000000) * 100);
    },
    voices() {
      let list = [];
      this.brands.map((b) => {
        list = list.concat(b.voices);
      });
      return list;
    },
  },
  data() {
    return {
      input: "",
      floatingInput: "",
      sheet: true,
      expand: false,
      showSources: false,
    };
  },
  methods: {
    async useSource(source) {
      console.log("Getting link preview");
      console.log(source);
      source.loading = true;
      const getPreview = httpsCallable(functions, "getLinkPreview");
      const res = await getPreview({
        url: source.url,
      });
      console.log(res.data);
      this.media = [
        {
          alt: res.data.images,
          type: "url",
          url: res.data.url,
          src: res.data.image,
          description: res.data.description,
          language: res.data.language,
          title: res.data.title,
        },
      ];
      source.loading = false;
    },
    linkify(t) {
      if (!t) return "";
      return t
        .replace(/(https?:\/\/[^\s<>"')]+|www\.[^\s<>"')]+)/gi, (m) => {
          // strip trailing punctuation
          const clean = m.replace(/[).,!?:]+$/, "");
          const href = clean.startsWith("http") ? clean : `https://${clean}`;
          return `<a href="${href}" target="_blank" rel="noopener noreferrer">${clean}</a>`;
        })
        .replace(/\n/g, "<br>");
    },
    loadRecentChat() {
      this.$store.commit("setLoadingRecentChat", true);
      this.$store.commit("setChatUid", this.recent_chat_uid);
      this.recent_chat = [];
      this.$store.commit("unsubscribe");
      this.$store.dispatch("initializeChat");
    },
    sendMessage(message) {
      this.input = message;

      if (this.input.trim() && !this.loading) {
        this.$store.dispatch("AddChatMessage", this.input);
        this.input = "";
        this.expand = false;
      }
    },

    sendFloatingMessage() {
      if (this.floatingInput.trim() && !this.loading) {
        this.$store.dispatch("AddChatMessage", this.floatingInput);
        this.floatingInput = "";
        this.expand = false;
      }
    },

    formatPostContent(content) {
      if (!content) return "";
      return content.replace(/\n/g, "<br>");
    },

    copyToClipboard(content) {
      if (!content) return;
      navigator.clipboard
        .writeText(content)
        .then(() => {
          this.$store.commit("setNotification", {
            show: true,
            text: "Post copied to clipboard!",
            type: "primary",
            icon: "",
          });
        })
        .catch(() => {
          this.$store.commit("setNotification", {
            show: true,
            text: "Failed to copy to clipboard",
            type: "error",
            icon: "",
          });
        });
    },

    useIdea(idea) {
      this.idea = { ...idea };
      this.$store.commit("setNotification", {
        show: true,
        text: `Using idea: ${idea.idea.substring(0, 50)}...`,
        type: "success",
        icon: "",
      });
    },

    saveIdea(idea) {
      console.log(idea);
      this.$store.dispatch("saveIdea", idea);
      idea.saved = true;
      this.$store.commit("setNotification", {
        show: true,
        text: `Saving idea: ${idea.title}`,
        type: "success",
        icon: "",
      });
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .v-textarea textarea {
  font-size: 10pt !important;
}
:deep(.v-text-field input) {
  font-size: 10pt;
}

@import url("https://fonts.googleapis.com/css2?family=Meow+Script&display=swap");

.meow-script-regular {
  font-family: "Meow Script", cursive;
  font-weight: 800;
  font-style: normal;
  font-size: 22pt;
}

.animate__animated.animate__slideInRight {
  --animate-duration: 0.5s;
}

.agent-drawer {
  background: white;
  height: 100vh;
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
  z-index: 999;
  overflow: hidden;
  position: relative;
}

.floating-chat-input {
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 99999;
  width: 90%;
  max-width: 900px;
}

.floating-input-card {
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.15);
  }
}

.floating-text-field {
  .v-field__input {
    min-height: 48px;
  }
}

.floating-send-btn {
  transition: all 0.2s ease;

  &:hover {
    transform: scale(1.1);
  }
}
:deep(.v-text-field input) {
  font-size: 10pt;
}
// Responsive adjustments
@media (max-width: 768px) {
  .floating-chat-input {
    width: 95%;
    bottom: 15px;
  }
}
</style>
